import CategoryApi from '@/api/category-api';
import { showToast } from '@/helpers/toast-handler';

export async function fetchAllCategories(companyId, assessment = false) {
    try {
        const response = await CategoryApi.getAllCategories(companyId, assessment);
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch all categories');
    }
}

export async function createCategory(body) {
    try {
        const response = await CategoryApi.addCategory(body);
        const message = response.message == 'Ok' ? 'Category Created Successfully' : response.message;
        showToast(response, message);
        return response.data;
    } catch (error) {
        throw new Error('Failed to create new category');
    }
}

export async function updateCategory(id, body) {
    try {
        const response = await CategoryApi.updateCategory(id, body);
        const message = response.message == 'Ok' ? `Category ${id} updated successfully` : response.message;
        showToast(response, message);
        return response.data;
    } catch (error) {
        throw new Error('Failed to update category');
    }
}

export async function deleteCategory(id) {
    try {
        const response = await CategoryApi.deleteCategory(id);
        const message = response.message == 'Ok' ? `Category ${id} deleted successfully` : response.message;
        showToast(response, message);
        return response.data;
    } catch (error) {
        throw new Error('Failed to delete category');
    }
}
